export const ACCORDION_ID = "sports-bar";